import { useEffect, useState } from 'react';
import { isRecapVisible, RECAP_VISIBILITY_EVENT } from './recap-preference';

/**
 * The recap visibility preference as React state, kept in step with the stored value.
 *
 * Starts from the DEFAULT rather than from localStorage, and reads the real value in an effect: reading
 * storage during the first render makes the server and client disagree and React discards the markup.
 * The default is `true`, which is also the common case, so the correction is invisible unless recaps are
 * off — and then it is one frame.
 *
 * Listens to both the same-tab custom event and the cross-tab `storage` event, because the native one
 * does not fire in the tab that wrote the value.
 */
export function useRecapVisible(): boolean {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setVisible(isRecapVisible());
    const sync = () => setVisible(isRecapVisible());
    window.addEventListener(RECAP_VISIBILITY_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(RECAP_VISIBILITY_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return visible;
}
